<div class="{{ cssStyle }}">
  <div class="left">
    <ng-content select="[left]"></ng-content>
  </div>
  <h4 id="modal-title" class="title">{{ title }}</h4>
  <div class="right">
    <ng-content select="[right]"></ng-content>
  </div>
  @if (showIndicator && step) {
    <span class="indicator">{{ step }}</span>
  }
</div>
